<template lang="pug" src="./tab-about.pug"></template>

<script>
export default {
  data () {
    return {
      activeTab: 0,
      hoverTab: 0,
      mobileTabs: [0]
    }
  },
  props: ['props'],
  methods: {
    toggleMobileTab (i) {
      !this.mobileTabs.includes(i) ? this.mobileTabs.push(i) : this.mobileTabs.splice(this.mobileTabs.indexOf(i), 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// tab-about.vue?53f24e94